import Vue from "vue";
import VueRouter from "vue-router";
import AdminPanel from "../views/AdminPanel.vue";
import AdminUsers from "../views/AdminUsers.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "adminPanel",
    component: AdminPanel
  },
  {
    path: "/login", 
    name: "Login",
    component: Login
  },
  {
    path: "/users", 
    name: "AdminUsers",
    component: AdminUsers
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
